import(/* webpackMode: "eager" */ "/tmp/8de5786f4805c98/app/[locale]/error.tsx");
